"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralSettings = void 0;
const T = __importStar(require("@microsoft/fast-element"));
require("./template.html");
const client_1 = require("@rws-framework/client");
const backendImport_1 = require("@front/backendImport");
const component_1 = require("@front/layouts/default-layout/component");
// Import form-parts components
require("@front/components/form-parts");
require("@front/components/rag-settings/component");
require("@front/pages/settings/social-media/component");
const rag_default_setup_1 = require("../../../../../common/constants/rag-default-setup");
//@ts-ignore                
let rwsTemplate = T.html `﻿<div id="settings-general-page" class="container-fluid">
    <div class="page-header">
        <h1>${'settings.general.title'.t()}</h1>
        <p class="text-muted">${'settings.general.description'.t()}</p>
    </div>

    <div class="card">
        <div class="card-body">
            
            <ul class="nav nav-tabs nav-fill" role="tablist">
                <li class="nav-item">
                    <a class="nav-link ${x => x.activeTab === 'google-drive' ? 'active' : ''}" 
                       href="javascript:void(0);" 
                       @click="${x => x.switchToGoogleDriveTab()}">
                        <i class="bi bi-google me-1"></i>
                        ${'settings.general.tabs.googleDrive'.t()}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link ${x => x.activeTab === 'general' ? 'active' : ''}" 
                       href="javascript:void(0);" 
                       @click="${x => x.switchToGeneralTab()}">
                        <i class="bi bi-gear me-1"></i>
                        ${'settings.general.tabs.general'.t()}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link ${x => x.activeTab === 'api-keys' ? 'active' : ''}" 
                       href="javascript:void(0);" 
                       @click="${x => x.switchToApiKeysTab()}">
                        <i class="bi bi-key me-1"></i>
                        ${'settings.general.tabs.apiKeys'.t()}
                    </a>
                </li>
                <li class="nav-item ${x => x.isSuperAdmin ? '' : 'd-none'}">
                    <a class="nav-link ${x => x.activeTab === 'rag' ? 'active' : ''}" 
                       href="javascript:void(0);" 
                       @click="${x => x.switchToRagTab()}">
                        <i class="bi bi-cpu me-1"></i>
                        ${'settings.general.tabs.rag'.t()}
                    </a>
                </li>
                <li class="nav-item ${x => x.isSuperAdmin ? '' : 'd-none'}">
                    <a class="nav-link ${x => x.activeTab === 'credit' ? 'active' : ''}" 
                       href="javascript:void(0);" 
                       @click="${x => x.switchToCreditTab()}">
                        <i class="bi bi-currency-dollar me-1"></i>
                        ${'settings.general.tabs.credit'.t()}
                    </a>
                </li>
                <li class="nav-item">
                    <a class="nav-link ${x => x.activeTab === 'social-media' ? 'active' : ''}" 
                       href="javascript:void(0);" 
                       @click="${x => x.switchToSocialMediaTab()}">
                        <i class="bi bi-share me-1"></i>
                        ${'settings.general.tabs.socialMedia'.t()}
                    </a>
                </li>
            </ul>

            
            <div class="tab-content">
                
                <div class="tab-pane fade ${x => x.activeTab === 'google-drive' ? 'show active' : ''}" 
                     id="google-drive-tab">
                    <div class="pt-4">
                        <div class="google-drive-connection">
                            <div class="d-flex align-items-center mb-4">
                                <div class="me-3">
                                    <i class="bi bi-google fs-1 text-primary"></i>
                                </div>
                                <div class="flex-grow-1">
                                    <h6 class="mb-1">${'settings.googleDrive.title'.t()}</h6>
                                    <p class="text-muted mb-2">${'settings.googleDrive.simpleDescription'.t()}</p>
                                    <div class="d-flex align-items-center">
                                        <span class="badge me-2 ${x => x.googleDriveAuthenticated ? 'bg-success' : 'bg-secondary'}">
                                            <i class="bi ${x => x.googleDriveAuthenticated ? 'bi-check-circle' : 'bi-x-circle'} me-1"></i>
                                            ${x => x.googleDriveAuthenticated ? 'settings.status.connected'.t() : 'settings.status.notConnected'.t()}
                                        </span>
                                        <span class="spinner-border spinner-border-sm me-2 ${x => x.loading ? '' : 'd-none'}"></span>
                                    </div>
                                </div>
                            </div>

                            <div class="google-drive-actions">
                                
                                <div class="mb-3 ${x => x.googleDriveAuthenticated ? 'd-none' : ''}">
                                    <label for="googleDriveGmail" class="form-label">
                                        ${'settings.googleDrive.gmail.label'.t()}
                                    </label>
                                    <div class="input-group">
                                        <span class="input-group-text">
                                            <i class="simple-icon-envelope"></i>
                                        </span>
                                        <input 
                                            type="email" 
                                            class="form-control ${x => x.googleDriveGmail && !x.gmailValid ? 'is-invalid' : x.gmailValid ? 'is-valid' : ''}"
                                            id="googleDriveGmail"
                                            :value="${x => x.googleDriveGmail}"
                                            @input="${(x, c) => x.googleDriveGmail = c.event.target.value}"
                                            @keyup="${(x, c) => x.validateGmail()}"
                                            placeholder="${'settings.googleDrive.gmail.placeholder'.t()}"
                                            autocomplete="email"
                                        />
                                    </div>
                                    <div class="form-text ${x => x.googleDriveGmail && !x.gmailValid ? 'text-danger' : 'text-muted'}">
                                        ${x => x.googleDriveGmail && !x.gmailValid ? 'settings.googleDrive.gmail.invalid'.t() : 'settings.googleDrive.gmail.help'.t()}
                                    </div>
                                </div>

                                <button 
                                    type="button" 
                                    class="btn ${x => !x.gmailValid && !x.googleDriveAuthenticated ? 'btn-secondary' : 'btn-primary'} me-2 ${x => x.googleDriveAuthenticated ? 'd-none' : ''}"
                                    :disabled="${x => x.isConnecting || x.loading || !x.gmailValid}"
                                    @click="${x => x.connectGoogleDrive()}"
                                    title="${x => !x.gmailValid ? 'settings.googleDrive.gmail.enterValidGmail'.t() : 'settings.googleDrive.connectSimple'.t()}"
                                >
                                    <span class="spinner-border spinner-border-sm me-2 ${x => x.isConnecting ? '' : 'd-none'}"></span>
                                    <i class="bi bi-google me-1"></i>
                                    ${x => !x.gmailValid ? 'settings.googleDrive.enterGmailFirst'.t() : 'settings.googleDrive.connectSimple'.t()}
                                </button>

                                <button 
                                    type="button" 
                                    class="btn btn-outline-danger ${x => x.googleDriveAuthenticated ? '' : 'd-none'}"
                                    :disabled="${x => x.loading}"
                                    @click="${(x, c) => x.disconnectGoogleDrive(c.event)}"
                                >
                                    <i class="bi bi-x-circle me-1"></i>
                                    ${'settings.googleDrive.disconnect'.t()}
                                </button>
                            </div>

                            <div class="mt-4 ${x => x.googleDriveAuthenticated ? '' : 'd-none'}">
                                <div class="alert alert-success">
                                    <h6 class="alert-heading">
                                        <i class="bi bi-check-circle"></i>
                                        ${'settings.googleDrive.connected.title'.t()}
                                    </h6>
                                    <p class="mb-0">${'settings.googleDrive.connected.description'.t()}</p>
                                </div>                                                       
                            </div>
                        </div>

                        <hr />

                        <div class="alert alert-info">
                            <h6 class="alert-heading">
                                <i class="bi bi-info-circle"></i>
                                ${'settings.googleDrive.howItWorks.title'.t()}
                            </h6>
                            <ol class="mb-0">
                                <li>${'settings.googleDrive.howItWorks.step1'.t()}</li>
                                <li>${'settings.googleDrive.howItWorks.step2'.t()}</li>
                                <li>${'settings.googleDrive.howItWorks.step3'.t()}</li>
                            </ol>
                        </div>
                    </div>
                </div>

                
                <div class="tab-pane fade ${x => x.activeTab === 'general' ? 'show active' : ''}" 
                     id="general-tab">
                    <div class="pt-4">
                        <h5 class="mb-3">${'settings.general.tabs.general'.t()}</h5>
                        
                        <div class="row">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-body">
                                        <h6 class="card-title mb-3">
                                            <i class="bi bi-chat-dots me-2"></i>
                                            ${'settings.general.chatLearning.title'.t()}
                                        </h6>
                                        <p class="text-muted mb-3">${'settings.general.chatLearning.description'.t()}</p>
                                        
                                        <form @submit="${(x, c) => { c.event.preventDefault(); x.saveGeneralSettings(); }}">
                                            <div class="mb-3">
                                                <part-textarea
                                                    label="${'settings.general.chatLearning.summaryLabel'.t()}"
                                                    name="chatLearningSummary"
                                                    :value="${x => x.chatLearningSummary}"
                                                    @change="${(x, c) => x.handleChatLearningSummaryChange(c.event)}"
                                                    :disabled="${x => x.generalLoading}"
                                                    placeholder="${'settings.general.chatLearning.summaryPlaceholder'.t()}"
                                                    rows="8"
                                                ></part-textarea>
                                                <div class="form-text">
                                                    ${'settings.general.chatLearning.summaryHelp'.t()}
                                                </div>
                                            </div>

                                            <div class="d-flex gap-2">
                                                <button 
                                                    type="submit" 
                                                    class="btn btn-primary"
                                                    :disabled="${x => x.generalLoading}"
                                                >
                                                    <span class="spinner-border spinner-border-sm me-2 ${x => x.generalLoading ? '' : 'd-none'}"></span>
                                                    <i class="bi bi-check-lg me-1 ${x => x.generalLoading ? 'd-none' : ''}"></i>
                                                    ${'settings.general.save'.t()}
                                                </button>                                            
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="tab-pane fade ${x => x.activeTab === 'api-keys' ? 'show active' : ''}" 
                     id="api-keys-tab">
                    <div class="pt-4">
                        <h5 class="mb-3">${'settings.general.tabs.apiKeys'.t()}</h5>
                        <code class="api-key">${x => x.apiKey}</code>
                    </div>
                </div>

                
                <div class="tab-pane fade ${x => x.activeTab === 'rag' ? 'show active' : ''}" 
                     id="rag-tab">
                    <div class="pt-4">
                        <h5 class="mb-3">${'settings.general.tabs.rag'.t()}</h5>
                        <p class="text-muted mb-4">${'settings.rag.description'.t()}</p>

                        ${x => x.ragLoading ? `
                            <div class="d-flex justify-content-center p-3">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">${'common.loading'.t()}</span>
                                </div>
                            </div>
                        ` : ''}

                        <div class="${x => x.ragLoading ? 'd-none' : ''}">
                            
                            <div class="card mb-4">
                                <div class="card-header">
                                    <h6 class="mb-0">${'settings.rag.search.title'.t()}</h6>
                                </div>
                                <div class="card-body">
                                    <rag-settings 
                                        searching="true"
                                        indexing="true"
                                        @rag-settings-changed="${(x, c) => x.onRagSettingsChanged(c.event)}"
                                        :ragSettings="${x => x.ragSettings}">
                                    </rag-settings>
                                </div>
                            </div>

                            
                            <div class="d-flex justify-content-end">
                                <button type="button" class="btn btn-primary" 
                                        @click="${x => x.saveRAGSettings()}"
                                        ?disabled="${x => x.ragLoading}">
                                    <i class="bi bi-check-lg me-1"></i>
                                    ${'settings.rag.save'.t()}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="tab-pane fade ${x => x.activeTab === 'credit' ? 'show active' : ''}" 
                     id="credit-tab">
                    <div class="pt-4">
                        <h5 class="mb-3">${'settings.general.tabs.credit'.t()}</h5>
                        <p class="text-muted mb-4">${'settings.credit.description'.t()}</p>

                        ${x => x.creditLoading ? `
                            <div class="d-flex justify-content-center p-3">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">${'common.loading'.t()}</span>
                                </div>
                            </div>
                        ` : ''}

                        <div class="${x => x.creditLoading ? 'd-none' : ''}">
                            <div class="card">
                                <div class="card-header">
                                    <h6 class="mb-0">
                                        <i class="bi bi-currency-exchange me-2"></i>
                                        ${'settings.credit.conversion.title'.t()}
                                    </h6>
                                </div>
                                <div class="card-body">
                                    <form @submit="${(x, c) => { c.event.preventDefault(); x.saveCreditSettings(); }}">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <part-input
                                                    label="${'settings.credit.conversion.dollarToCreditRate'.t()}"
                                                    name="dollarToCreditRate"
                                                    type="number"
                                                    step="0.01"
                                                    min="0.01"
                                                    placeholder="100"
                                                    :value="${x => { var _a; return (_a = x.creditSettings.dollarToCreditRate) === null || _a === void 0 ? void 0 : _a.toString(); }}"
                                                    @change="${(x, c) => x.handleCreditRateChange(c.event)}"
                                                    :disabled="${x => x.creditLoading}"
                                                ></part-input>
                                                <div class="form-text">${'settings.credit.conversion.dollarToCreditRate.help'.t()}</div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="alert alert-info mt-4">
                                                    <h6 class="alert-heading">
                                                        <i class="bi bi-info-circle"></i>
                                                        ${'settings.credit.preview.title'.t()}
                                                    </h6>
                                                    <p class="mb-1 mr-1">
                                                        <strong>1.00 USD</strong> = <strong>${x => x.creditSettings.dollarToCreditRate} ${'settings.credit.credits'.t()}</strong>
                                                    </p>
                                                    <p class="mb-0">
                                                        <strong>10.00 USD</strong> = <strong>${x => (x.creditSettings.dollarToCreditRate * 10)} ${'settings.credit.credits'.t()}</strong>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="d-flex gap-2 mt-3">
                                            <button 
                                                type="submit" 
                                                class="btn btn-primary"
                                                :disabled="${x => x.creditLoading}"
                                            >
                                                <span class="spinner-border spinner-border-sm me-2 ${x => x.creditLoading ? '' : 'd-none'}"></span>
                                                <i class="bi bi-check-lg me-1 ${x => x.creditLoading ? 'd-none' : ''}"></i>
                                                ${'settings.credit.save'.t()}
                                            </button>                                                                                   
                                        </div>
                                    </form>
                                </div>
                            </div>

                            <div class="mt-4">
                                <div class="alert alert-warning">
                                    <h6 class="alert-heading">
                                        <i class="bi bi-exclamation-triangle"></i>
                                        ${'settings.credit.warning.title'.t()}
                                    </h6>
                                    <p class="mb-0">${'settings.credit.warning.description'.t()}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="tab-pane fade ${x => x.activeTab === 'social-media' ? 'show active' : ''}" 
                     id="social-media-tab">
                    <settings-social-media></settings-social-media>
                </div>
            </div>
        </div>
    </div>
</div>`;
require("./styles/layout.scss");
const styles = T.css `#settings-general-page .page-header {
  margin-bottom: 2rem;
}
#settings-general-page .page-header h1 {
  color: var(--bs-primary);
  font-weight: 600;
}
#settings-general-page .card {
  border: 1px solid var(--bs-border-color);
  border-radius: 0.75rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
#settings-general-page .card .card-header {
  background-color: var(--bs-light);
  border-bottom: 1px solid var(--bs-border-color);
}
#settings-general-page .card .card-header .card-title {
  margin-bottom: 0;
  font-weight: 600;
  color: var(--bs-dark);
}
#settings-general-page .card .card-header .card-title i {
  margin-right: 0.5rem;
  color: var(--bs-primary);
}
#settings-general-page .card .card-body {
  padding: 2rem;
}
#settings-general-page .google-drive-status .status-indicator .badge {
  font-size: 0.875rem;
  padding: 0.5rem 0.75rem;
}
#settings-general-page .google-drive-actions .btn {
  font-weight: 500;
}
#settings-general-page .google-drive-actions .btn i {
  font-size: 1rem;
}
#settings-general-page .alert-info {
  background-color: rgba(var(--bs-info-rgb), 0.1);
  border-color: rgba(var(--bs-info-rgb), 0.2);
  color: var(--bs-info-text);
}
#settings-general-page .alert-info .alert-heading {
  color: var(--bs-info-text);
  font-weight: 600;
  margin-bottom: 1rem;
}
#settings-general-page .alert-info .alert-heading i {
  margin-right: 0.5rem;
}
#settings-general-page .alert-info ol {
  padding-left: 1.5rem;
}
#settings-general-page .alert-info ol li {
  margin-bottom: 0.5rem;
  line-height: 1.5;
}
#settings-general-page .form-text {
  font-size: 0.875rem;
  color: var(--bs-secondary);
  margin-top: 0.25rem;
}
#settings-general-page .spinner-border-sm {
  width: 1rem;
  height: 1rem;
}
#settings-general-page .google-drive-connection .input-group-text .simple-icons-envelope {
  color: var(--bs-secondary);
  font-size: 1rem;
}
#settings-general-page .google-drive-connection .btn-secondary:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}
#settings-general-page .google-drive-connection .btn-secondary:disabled .bi-google {
  opacity: 0.5;
}
#settings-general-page .google-drive-connection .form-control.is-valid {
  border-color: var(--bs-success);
}
#settings-general-page .google-drive-connection .form-control.is-valid:focus {
  border-color: var(--bs-success);
  box-shadow: 0 0 0 0.2rem rgba(var(--bs-success-rgb), 0.25);
}
#settings-general-page .google-drive-connection .form-control.is-invalid {
  border-color: var(--bs-danger);
}
#settings-general-page .google-drive-connection .form-control.is-invalid:focus {
  border-color: var(--bs-danger);
  box-shadow: 0 0 0 0.2rem rgba(var(--bs-danger-rgb), 0.25);
}
#settings-general-page .google-drive-connection .form-text.text-danger {
  color: var(--bs-danger) !important;
  font-weight: 500;
}`;
const shadowOptions = { "mode": "open" };
let GeneralSettings = class GeneralSettings extends client_1.RWSViewComponent {
    constructor() {
        super();
        this.loading = false;
        this.googleDriveAuthenticated = false;
        this.isConnecting = false;
        this.activeTab = 'google-drive';
        this.googleDriveGmail = '';
        this.gmailValid = false;
        this.isSuperAdmin = false;
        this.apiKey = null;
        this.ragLoading = false;
        this.ragSettings = {
            defaultMaxResults: rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultMaxResults || 3,
            maxResults: rag_default_setup_1.RAG_DEFAULT_SETUP.search.maxResults || 6,
            similarityThreshold: rag_default_setup_1.RAG_DEFAULT_SETUP.search.defaultSimilarityThreshold || 0.45,
            chunkSize: rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkSize,
            chunkOverlap: rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.chunkOverlap,
            separators: [...rag_default_setup_1.RAG_DEFAULT_SETUP.chunking.separators]
        };
        this.chatLearningSummary = '';
        this.generalLoading = false;
        this.creditLoading = false;
        this.creditSettings = {
            dollarToCreditRate: 100
        };
    }
    async connectedCallback() {
        super.connectedCallback();
        await this.loadGoogleDriveStatus();
        await this.checkUserPermissions();
        await this.loadUserSettings();
        if (this.isSuperAdmin) {
            await this.loadGlobalSettings();
            await this.loadCreditSettings();
        }
        this.initializeRagSettingsComponent();
        this.handleHashChange(); // Initial check for hash on load
        window.addEventListener('hashchange', this.handleHashChange.bind(this));
    }
    async disconnectedCallback() {
        window.removeEventListener('hashchange', this.handleHashChange.bind(this));
        super.disconnectedCallback();
    }
    handleHashChange() {
        const tabName = window.location.hash.substring(1);
        if (!tabName || tabName === this.activeTab) {
            return;
        }
        this.activeTab = tabName;
    }
    googleDriveGmailChanged() {
        this.validateGmail();
    }
    validateGmail() {
        const emailRegex = /^[^\s@]+@gmail\.com$/i;
        this.gmailValid = this.googleDriveGmail.trim() !== '' && emailRegex.test(this.googleDriveGmail.trim());
    }
    async loadGoogleDriveStatus() {
        this.loading = true;
        try {
            const response = await this.apiService.back.get('settings.google-drive.status');
            if (response && response.success && response.data) {
                this.googleDriveAuthenticated = response.data.authenticated;
                this.loading = false;
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('settings.failedToLoad'.t(), 'error');
            this.loading = false;
        }
    }
    async connectGoogleDrive() {
        if (!this.gmailValid) {
            this.notifyService.notify('settings.googleDrive.invalidGmail'.t(), 'error');
            return;
        }
        this.isConnecting = true;
        try {
            const response = await this.apiService.back.post('settings.google-drive.auth', {
                gmail: this.googleDriveGmail
            });
            if (response && response.success && response.data) {
                const popup = window.open(response.data.authUrl, 'GoogleDriveAuth', 'width=500,height=600,scrollbars=yes,resizable=yes');
                const checkClosed = setInterval(() => {
                    if (popup === null || popup === void 0 ? void 0 : popup.closed) {
                        clearInterval(checkClosed);
                        this.loadGoogleDriveStatus();
                        this.isConnecting = false;
                    }
                }, 1000);
                this.notifyService.notify('settings.googleDrive.authWindowOpened'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.googleDrive.failedToGetAuthUrl'.t(), 'error');
                this.isConnecting = false;
            }
        }
        catch (e) {
            console.error(e);
            this.notifyService.notify('settings.googleDrive.failedToGetAuthUrl'.t(), 'error');
            this.isConnecting = false;
        }
    }
    async disconnectGoogleDrive(event) {
        event.preventDefault();
        this.isConnecting = true;
        try {
            const response = await this.apiService.back.post('settings.google-drive.disconnect');
            if (response && response.success) {
                this.googleDriveAuthenticated = false;
                this.notifyService.notify('settings.general.googleDrive.disconnectSuccess'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.general.googleDrive.disconnectError'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Google Drive disconnection failed:', error);
            this.notifyService.notify('settings.general.googleDrive.disconnectError'.t(), 'error');
        }
        finally {
            this.isConnecting = false;
        }
    }
    // Tab management
    switchToGoogleDriveTab() { this.activeTab = 'google-drive'; }
    switchToGeneralTab() { this.activeTab = 'general'; }
    switchToApiKeysTab() { this.activeTab = 'api-keys'; }
    switchToRagTab() { this.activeTab = 'rag'; }
    switchToCreditTab() { this.activeTab = 'credit'; }
    switchToSocialMediaTab() {
        this.activeTab = 'social-media';
    }
    async checkUserPermissions() {
        try {
            this.isSuperAdmin = component_1.DefaultLayout.USER.role === backendImport_1.UserRoles.SUPER_ADMIN;
        }
        catch (error) {
            console.error('Failed to check user permissions:', error);
            this.isSuperAdmin = false;
        }
    }
    async loadGeneralSettings() {
        this.generalLoading = true;
        try {
            const response = await this.apiService.back.get('settings.get');
            if (response && response.success && response.data) {
                this.chatLearningSummary = response.data.chatLearningSummary || '';
            }
        }
        catch (error) {
            console.error('Failed to load general settings:', error);
            this.notifyService.notify('settings.general.failedToLoad'.t(), 'error');
        }
        finally {
            this.generalLoading = false;
        }
    }
    async loadUserSettings() {
        var _a;
        this.generalLoading = true;
        try {
            this.apiKey = ((_a = (await this.apiService.back.get('user.get-apiKey', { routeParams: { id: String(component_1.DefaultLayout.USER.id) } })).data) === null || _a === void 0 ? void 0 : _a.apiKey) || null;
            const response = await this.apiService.back.get('settings.get');
            if (response && response.success && response.data) {
                this.chatLearningSummary = response.data.chatLearningSummary || '';
            }
        }
        catch (error) {
            console.error('Failed to load user settings:', error);
            this.notifyService.notify('settings.general.failedToLoad'.t(), 'error');
        }
        finally {
            this.generalLoading = false;
        }
    }
    async loadGlobalSettings() {
        this.ragLoading = true;
        try {
            const response = await this.apiService.back.get('settings.get', { queryParams: { global: '1' } });
            if (response && response.success && response.data) {
                if (response.data.defaultMaxResults !== undefined)
                    this.ragSettings.defaultMaxResults = response.data.defaultMaxResults;
                if (response.data.maxResults !== undefined)
                    this.ragSettings.maxResults = response.data.maxResults;
                if (response.data.similarityThreshold !== undefined)
                    this.ragSettings.similarityThreshold = response.data.similarityThreshold;
                if (response.data.chunkSize !== undefined)
                    this.ragSettings.chunkSize = response.data.chunkSize;
                if (response.data.chunkOverlap !== undefined)
                    this.ragSettings.chunkOverlap = response.data.chunkOverlap;
                if (response.data.separators !== undefined)
                    this.ragSettings.separators = response.data.separators;
                this.ragSettings = { ...this.ragSettings };
                this.initializeRagSettingsComponent();
            }
        }
        catch (error) {
            console.error('Failed to load global settings:', error);
            this.notifyService.notify('settings.rag.failedToLoad'.t(), 'error');
        }
        finally {
            this.ragLoading = false;
        }
    }
    handleChatLearningSummaryChange(event) {
        var _a, _b, _c;
        let value = '';
        if (event instanceof CustomEvent) {
            if (event.type === 'change' && ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.value) !== undefined) {
                value = event.detail.value;
            }
            else if (((_b = event.detail) === null || _b === void 0 ? void 0 : _b.value) !== undefined) {
                value = event.detail.value;
            }
        }
        else if (((_c = event.target) === null || _c === void 0 ? void 0 : _c.value) !== undefined) {
            value = event.target.value;
        }
        this.chatLearningSummary = value;
    }
    async saveGeneralSettings() {
        this.generalLoading = true;
        try {
            const response = await this.apiService.back.post('settings.update', {
                chatLearningSummary: this.chatLearningSummary
            });
            if (response && response.success) {
                this.notifyService.notify('settings.general.savedSuccessfully'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.general.failedToSave'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to save general settings:', error);
            this.notifyService.notify('settings.general.failedToSave'.t(), 'error');
        }
        finally {
            this.generalLoading = false;
        }
    }
    onRagSettingsChanged(event) {
        if (event.detail && event.detail.settings) {
            this.ragSettings = { ...this.ragSettings, ...event.detail.settings };
        }
    }
    initializeRagSettingsComponent() {
        setTimeout(() => {
            const ragSettingsComponent = this.$('rag-settings');
            if (ragSettingsComponent && ragSettingsComponent.setSettings) {
                ragSettingsComponent.setSettings(this.ragSettings);
            }
        }, 100);
    }
    async saveRAGSettings() {
        this.ragLoading = true;
        try {
            const response = await this.apiService.back.post('settings.update', this.ragSettings, { queryParams: { global: '1' } });
            if (response && response.success) {
                this.notifyService.notify('settings.rag.savedSuccessfully'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.rag.failedToSave'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to save RAG settings:', error);
            this.notifyService.notify('settings.rag.failedToSave'.t(), 'error');
        }
        finally {
            this.ragLoading = false;
        }
    }
    onSingleFileSelected(event) {
        const file = event.detail.file;
        console.log('Single file selected:', file);
        this.notifyService.notify(`File selected: ${file.name}`, 'info');
    }
    onMultipleFilesSelected(event) {
        const files = event.detail.files;
        console.log('Multiple files selected:', files);
        this.notifyService.notify(`${files.length} files selected`, 'info');
    }
    onPickerCancelled() {
        console.log('File picker cancelled');
        this.notifyService.notify('File picker cancelled', 'info');
    }
    async loadCreditSettings() {
        this.creditLoading = true;
        try {
            const response = await this.apiService.back.get('settings.get', { queryParams: { global: '1' } });
            if (response && response.success && response.data) {
                if (response.data.dollarToCreditRate !== undefined) {
                    this.creditSettings.dollarToCreditRate = response.data.dollarToCreditRate;
                }
            }
        }
        catch (error) {
            console.error('Failed to load credit settings:', error);
            this.notifyService.notify('settings.credit.failedToLoad'.t(), 'error');
        }
        finally {
            this.creditLoading = false;
        }
    }
    handleCreditRateChange(event) {
        var _a, _b, _c;
        let value = '';
        if (event instanceof CustomEvent) {
            if (event.type === 'change' && ((_a = event.detail) === null || _a === void 0 ? void 0 : _a.value) !== undefined) {
                value = event.detail.value;
            }
            else if (((_b = event.detail) === null || _b === void 0 ? void 0 : _b.value) !== undefined) {
                value = event.detail.value;
            }
        }
        else if (((_c = event.target) === null || _c === void 0 ? void 0 : _c.value) !== undefined) {
            value = event.target.value;
        }
        const numValue = parseFloat(value.toString()) || 100;
        this.creditSettings.dollarToCreditRate = Math.max(0.01, numValue);
    }
    async saveCreditSettings() {
        this.creditLoading = true;
        try {
            const response = await this.apiService.back.post('settings.update', {
                dollarToCreditRate: this.creditSettings.dollarToCreditRate
            }, { queryParams: { global: '1' } });
            if (response && response.success) {
                this.notifyService.notify('settings.credit.savedSuccessfully'.t(), 'info');
            }
            else {
                this.notifyService.notify((response === null || response === void 0 ? void 0 : response.error) || 'settings.credit.failedToSave'.t(), 'error');
            }
        }
        catch (error) {
            console.error('Failed to save credit settings:', error);
            this.notifyService.notify('settings.credit.failedToSave'.t(), 'error');
        }
        finally {
            this.creditLoading = false;
        }
    }
};
exports.GeneralSettings = GeneralSettings;
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "loading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "googleDriveAuthenticated", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "isConnecting", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GeneralSettings.prototype, "activeTab", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GeneralSettings.prototype, "googleDriveGmail", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "gmailValid", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "isSuperAdmin", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GeneralSettings.prototype, "apiKey", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "ragLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", typeof (_a = typeof backendImport_1.ISettings !== "undefined" && backendImport_1.ISettings) === "function" ? _a : Object)
], GeneralSettings.prototype, "ragSettings", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", String)
], GeneralSettings.prototype, "chatLearningSummary", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "generalLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Boolean)
], GeneralSettings.prototype, "creditLoading", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], GeneralSettings.prototype, "creditSettings", void 0);
exports.GeneralSettings = GeneralSettings = __decorate([
    (0, client_1.RWSView)('settings-general', null, { template: rwsTemplate, styles, options: { shadowOptions } }),
    __metadata("design:paramtypes", [])
], GeneralSettings);
GeneralSettings.defineComponent();
